// Fifty2 Tuesdays — imported from fifty2-tuesdays.emergent.host (52 weeks). Edit text here.
export const FIFTY2_ID = 'fifty2-tuesdays';
export const ORIGINAL_START = '2026-03-24';
export const heroImage = '/images/fifty2-cover.png';
export const intro = 'A quiet weekly practice for steadier living — 52 weeks of mindfulness, one casual Tuesday at a time. Each week brings reflection, insights and affirmations for our personal expansion. Like having friendly coffee with yourself.';
export const yearCompass = {
  "eyebrow": "A Year Compass",
  "lead": "This is not a year to brace against. It is a year to refine your center.",
  "body": [
    "You will feel acceleration. Information will multiply. Opinions will sharpen. Systems will wobble.",
    "Do not confuse motion with direction.",
    "Your work this year is subtle and powerful:"
  ],
  "strengthen": [
    "Strengthen your nervous system.",
    "Strengthen your discernment.",
    "Strengthen your capacity to pause before reacting."
  ],
  "close": [
    "There will be invitations to polarize. Choose depth instead.",
    "There will be urgency in the air. Move with intention, not impulse.",
    "You do not need to predict the future to walk well into it. You need rhythm. You need regulation. You need small, repeatable practices that anchor you back into your body.",
    "Let this be the year you practice returning. Again and again and again."
  ],
  "final": "Center is not found once. It is remembered daily.",
  "welcome": "Welcome to the unfolding."
};
export const monthlyGuidance = {
  "1": {
    "title": "Completion",
    "guidance": "Close loops. Finish what lingers. Energy returns when cycles are completed."
  },
  "2": {
    "title": "Integration",
    "guidance": "Before rushing into the next beginning, pause. Notice who you have become."
  },
  "3": {
    "title": "Recalibration",
    "guidance": "The new cycle begins quietly. Adjust gently. Not everything needs force. Alignment first, action second."
  },
  "4": {
    "title": "Friction",
    "guidance": "If something rubs, notice what is being strengthened. Tension is often refinement in disguise."
  },
  "5": {
    "title": "Visibility",
    "guidance": "What rises to the surface now was ready long ago. Let illumination clarify, not shame."
  },
  "6": {
    "title": "Acceleration",
    "guidance": "Things may speed up. Slow your breath before you speed your decisions."
  },
  "7": {
    "title": "Emotional Weather",
    "guidance": "Collective emotion may feel amplified. Feel what is yours. Release what is not."
  },
  "8": {
    "title": "Integrity",
    "guidance": "Small misalignments will feel louder. Correct course early. It saves energy later."
  },
  "9": {
    "title": "Expansion",
    "guidance": "Opportunity will not always look comfortable. Growth rarely does. Expand without abandoning your boundaries."
  },
  "10": {
    "title": "Nervous System Check",
    "guidance": "If you feel reactive, your body is asking for safety, not more information."
  },
  "11": {
    "title": "Discernment",
    "guidance": "Not every invitation deserves your yes. Clarity is kindness to your future self."
  },
  "12": {
    "title": "Simplification",
    "guidance": "When complexity increases, simplify your rituals. Eat simply. Move simply. Speak simply."
  }
};
export const weeks = [
  {
    "n": 1,
    "date": "March 24, 2026",
    "title": "The Awakening",
    "theme": "You're Not Crazy. You're Waking Up.",
    "cosmic": "Spring Equinox just passed. The planet is literally tilting toward the light. If you've been feeling restless, unsettled, like something BIG is coming—you're not imagining it. This is the universe's reset button. You pressed it. Now show up.",
    "exercise": "Go outside. Stand with bare feet on the earth if you can. Close your eyes. Feel the spin of the planet beneath you. You are standing on a rock hurtling through space at 67,000 mph and somehow your heart is still beating. You're already a miracle. Now breathe like you believe it. 5 breaths. Deep. Slow. You're here. You made it.",
    "affirmation": "I am not broken. I am breaking open. There's a difference.",
    "crystal": {
      "name": "Clear Quartz",
      "meaning": "This stone doesn't add anything—it amplifies what's already inside you. Your intentions. Your power. It's been waiting for you to remember.",
      "color": "#F5F5F5"
    },
    "oil": {
      "name": "Lemon",
      "meaning": "Sharp. Clean. Cuts through the fog. If your mind has been cloudy, this is your clarity. Inhale it like you're breathing in a fresh start—because you are.",
      "color": "#FFF44F"
    },
    "frequency": {
      "hz": 528,
      "name": "The Miracle Tone",
      "description": "This frequency literally repairs DNA. Science. Not woo. Your cells are listening. Give them something worth hearing."
    },
    "practice": {
      "type": "Loop Interrupter",
      "title": "Pause Before Urgency",
      "description": "When momentum builds, pause before replying to anything that feels urgent. The pause could be absolute money and saving time and energy in an unneeded battle or misunderstandings.",
      "practices": [
        "Pause",
        "Sleep on it if required",
        "Go for a walk",
        "Grab a coffee/tea",
        "Talk to a friend/colleague, speak about situation or simply take a break and speak about other aspects of life",
        "Let your brain wander away and then return with fresh viewpoint"
      ]
    },
    "image": "https://images.unsplash.com/photo-1602533185168-9e7f8ef3f435?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 2,
    "date": "March 31, 2026",
    "title": "The Fire Inside",
    "theme": "Stop Dimming Your Light For People Who Can't Handle It",
    "cosmic": "Aries season is FIRE. Raw. Unapologetic. You've spent too long making yourself smaller so others feel comfortable. That ends now. The universe doesn't reward people-pleasing. It rewards authenticity.",
    "exercise": "Stand up. Hands on hips. Chin up. Take up SPACE. Breathe in through your nose like you're inhaling your own power back from everyone who ever made you feel 'too much.' You're not too much. They were too little. Hold this pose for 2 minutes. Feel ridiculous. Do it anyway. Warriors don't care about looking silly.",
    "affirmation": "I am not 'too much.' I am exactly enough. And the right people will never ask me to shrink.",
    "crystal": {
      "name": "Carnelian",
      "meaning": "This is the stone of people who are done apologizing for existing. It's liquid courage in rock form. Carry it when you need to remember who you are.",
      "color": "#B31B1B"
    },
    "oil": {
      "name": "Ginger",
      "meaning": "Burns going in. Wakes you up. Like a friend who tells you the truth you didn't want to hear. You need this.",
      "color": "#B06500"
    },
    "frequency": {
      "hz": 396,
      "name": "Liberation Frequency",
      "description": "Releases fear, guilt, and all the heavy things you've been carrying that were never yours to carry."
    },
    "practice": {
      "type": "Somatic Anchor",
      "title": "Feel Your Feet",
      "description": "Feel your feet before you make a decision this week. Decisions made in 'impulse mode' may or may not go well. Trust yourself and find your feet first...they will be your greatest advocate this week.",
      "practices": [
        "Stand and move feet around on floor to heighten footprint awareness",
        "Colour your feet in your imagination",
        "Imagine standing in a puddle of colour of choice. Sometimes a colour arrives, sometimes we can assign a colour. Change colour if it feels appropriate.",
        "You can literally trace your feet on the floor on some paper. Can even colour them in"
      ]
    },
    "image": "https://images.unsplash.com/photo-1636022250354-fab41ffa27de?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 3,
    "date": "April 7, 2026",
    "title": "The Softening",
    "theme": "Your Armor Protected You. Now It's Suffocating You.",
    "cosmic": "Pink Moon rises this week. Full moons illuminate what's hidden. Yours has been hiding behind walls you built to survive. Those walls were necessary. They kept you safe. But safety isn't the same as living. It's time to let something in.",
    "exercise": "Put both hands on your heart. Feel it beating—this thing that's been broken and bruised and somehow keeps going anyway. Say out loud: 'I am safe to feel. I am safe to love. I am safe to be loved.' If it makes you cry, good. That's the armor cracking. Let it.",
    "affirmation": "My heart has been through hell and still knows how to love. That's not weakness. That's power.",
    "crystal": {
      "name": "Rose Quartz",
      "meaning": "The stone of unconditional love—including for yourself. Especially for yourself. Put it by your bed. Let it remind you that you deserve the love you keep giving everyone else.",
      "color": "#FFB6C1"
    },
    "oil": {
      "name": "Rose",
      "meaning": "The queen of all oils. Ancient. Precious. It takes 10,000 roses to make one bottle. You're worth 10,000 roses. Act like it.",
      "color": "#FF007F"
    },
    "frequency": {
      "hz": 639,
      "name": "Heart Frequency",
      "description": "Heals relationships—especially the one with yourself. That's where all the others begin."
    },
    "practice": {
      "type": "Discernment Filter",
      "title": "Guard Your Nervous System",
      "description": "Not every piece of information deserves entry into your nervous system. Practicing the value of energy like...'is this valuable for me now?', 'is this in my highest good?'...trust me...your nervous system will thank you.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1764248163996-d55aa8520cbe?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 4,
    "date": "April 14, 2026",
    "title": "The Vision",
    "theme": "You're Allowed To Want More. You're Allowed To Have It.",
    "cosmic": "New Moon in Aries on April 17th. New Moons are for planting seeds. But here's the thing—you can't plant seeds if you don't believe you deserve a garden. You do. You deserve the whole damn garden.",
    "exercise": "Write down 10 things you want. Not what's 'realistic.' Not what you 'should' want. What you actually want. The big, ridiculous, who-do-you-think-you-are dreams. Write them as if they already happened: 'I am... I have...' Read them out loud. To the sky. To the moon. To whoever's listening. Because someone is.",
    "affirmation": "I am allowed to want more. I am allowed to have it. I am allowed to become someone I've never been.",
    "crystal": {
      "name": "Pyrite",
      "meaning": "Fool's gold? No. Manifestor's gold. This stone says: 'I know my worth and I'm not negotiating.' Put it in your pocket when you need backup.",
      "color": "#CFB53B"
    },
    "oil": {
      "name": "Bay Laurel",
      "meaning": "Ancient Greeks crowned champions with laurel. Crown yourself. No one else is going to do it for you.",
      "color": "#5F8A3F"
    },
    "frequency": {
      "hz": 852,
      "name": "Third Eye Frequency",
      "description": "Opens intuition. Helps you see what you've been too afraid to look at—including your own potential."
    },
    "practice": {
      "type": "Cognitive Tool",
      "title": "Question Your Stories",
      "description": "Ask: what story am I assuming is true? We have a nervous system that searches for truth and certainty where sometimes there isn't any. We associate and search for meaning and anchors where it can often be creating a limitation for us from seeing other possibilities.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1725799957338-51f677c0ffa3?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 5,
    "date": "April 21, 2026",
    "title": "The Body Remembers",
    "theme": "You Can't Think Your Way Out Of What You Felt Your Way Into",
    "cosmic": "Taurus season. Earth energy. Your body has been screaming and you've been answering with your mind. Stop. The tension in your shoulders, the knot in your stomach, the exhaustion that sleep doesn't fix—these are messages. Start listening.",
    "exercise": "Eat one thing slowly. Really slowly. Look at it. Smell it. Feel the texture. Chew until it's liquid. You've been rushing through everything—meals, moments, your life. This is practice for presence. If you can be present with a strawberry, you can be present with anything.",
    "affirmation": "My body is not the enemy. It's the messenger. I'm finally ready to listen.",
    "crystal": {
      "name": "Green Aventurine",
      "meaning": "Stone of opportunity and luck—but luck isn't random. Luck is what happens when preparation meets presence. This stone helps you show up.",
      "color": "#568203"
    },
    "oil": {
      "name": "Sandalwood",
      "meaning": "Used in sacred rituals for 4,000 years. That's 4,000 years of humans finding stillness through this scent. Join them.",
      "color": "#C2B280"
    },
    "frequency": {
      "hz": 417,
      "name": "Sacral Chakra Frequency",
      "description": "Where you store emotion, creativity, and everything you've been too busy to feel. Time to clear the backlog."
    },
    "practice": {
      "type": "Emotional Barometer",
      "title": "Name the Exact Feeling",
      "description": "Name the exact feeling, not the summary. It can be really tough for us to sink into the FEELING. Notice if you are dancing around your feeling with justifications, excessive words, excess chaos. Name it...move forward. One word. It's hard...but worth it.",
      "practices": [
        "Allow everything to be. No justification, no defending the feelings. Just almost a factual account:",
        "Part of me feels _______",
        "Of course part of me feels ______",
        "Part of me has every right to feel ________ because _______",
        "Name everything and anything. Go 20 times."
      ]
    },
    "image": "https://images.unsplash.com/photo-1764559784651-f5e055f87b32?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 6,
    "date": "April 28, 2026",
    "title": "The Disruption",
    "theme": "Chaos Isn't The Enemy. Stagnation Is.",
    "cosmic": "Uranus just entered Gemini for a 7-year stay. Last time this happened, the world invented television. Revolution is in the air. If your life feels like it's shaking—good. Earthquakes break things open. Sometimes that's how the light gets in.",
    "exercise": "Do one thing completely different today. Take a new route. Talk to a stranger. Order something you'd never order. Break a pattern—any pattern. Notice how your body responds. That discomfort? It's not danger. It's growth.",
    "affirmation": "I don't fear change. I fear staying the same. And I'm done being afraid.",
    "crystal": {
      "name": "Labradorite",
      "meaning": "The stone of transformation. It looks like magic because it IS magic—light trapped in stone, revealing itself only when the angle is right. Like you.",
      "color": "#1E3A5F"
    },
    "oil": {
      "name": "Peppermint",
      "meaning": "Sharp. Alert. Wakes you up when you've been sleepwalking through your own life. Inhale and open your eyes.",
      "color": "#98FF98"
    },
    "frequency": {
      "hz": 741,
      "name": "Expression Frequency",
      "description": "Helps you speak what's true even when your voice shakes. The world needs your voice. Use it."
    },
    "practice": {
      "type": "Loop Interrupter",
      "title": "Victory Posture",
      "description": "Change posture before changing your mind. Stand up, lift your arms up high! Like VICTORY! Like a V with your arms. This will noticeably change your posture...even more valuable...the internal rod that is your spine, sacred and useful for posture.",
      "practices": [
        "Stand up tall",
        "Lift arms up in a V shape",
        "Like arms up in Sun Salutations",
        "Fun fact: Nike was the Greek Goddess of Victory - a symbol of success in all human endeavors"
      ]
    },
    "image": "https://images.unsplash.com/photo-1588720697792-dbc240fad57e?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 7,
    "date": "May 5, 2026",
    "title": "The Bloom",
    "theme": "You've Been A Seed In Dark Soil. Now Push Through.",
    "cosmic": "Flower Moon illuminates the sky. Pluto goes retrograde, taking transformation underground. You might feel like nothing's happening. Everything is happening. Seeds don't grow in public. They grow in darkness until they're ready. You're ready.",
    "exercise": "Close your eyes. See yourself as a seed underground. Dark. Quiet. Alone. Now feel roots pushing down, stem pushing up. See yourself breaking through the soil into light. Open your eyes. You just did in 30 seconds what you've been afraid to do for years. Now do it in real life.",
    "affirmation": "I was never stuck. I was rooting. And now I rise.",
    "crystal": {
      "name": "Peridot",
      "meaning": "Born in volcanoes and fallen from space in meteors. This stone knows about emerging from impossible circumstances. So do you.",
      "color": "#9ACD32"
    },
    "oil": {
      "name": "Geranium",
      "meaning": "Balancing. Grounding. Reminds you that growth isn't always dramatic. Sometimes it's just showing up, day after day, becoming.",
      "color": "#C73E3A"
    },
    "frequency": {
      "hz": 528,
      "name": "Growth Frequency",
      "description": "Cellular regeneration. You are literally rebuilding yourself from the inside out. Let this sound help."
    },
    "practice": {
      "type": "Emotional Barometer",
      "title": "Notice the Surge",
      "description": "When something is revealed, notice your first emotional surge without acting on it. Where is it in the body? Is it sharp? Dull? Heavy? Firey? Does it have a colour? Temperature? Edges?",
      "practices": [
        "Consider drawing it",
        "Sit with it",
        "Don't act on it immediately"
      ]
    },
    "image": "https://images.unsplash.com/photo-1749937393049-d0a0dbaed903?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 8,
    "date": "May 12, 2026",
    "title": "Enough",
    "theme": "You Are Not What You Produce. You Are Not What You Achieve.",
    "cosmic": "New Moon in Taurus on May 16th. Taurus energy says: you are worthy just by existing. Not by earning. Not by achieving. By BEING. Revolutionary concept for overachievers and perfectionists.",
    "exercise": "Hold something meaningful to you. Feel its weight. Now ask yourself: 'What would I be worth if I never achieved anything else?' The answer is: everything. You'd still be everything. Let that sink in.",
    "affirmation": "I am not my productivity. I am not my usefulness. I am worthy at rest.",
    "crystal": {
      "name": "Citrine",
      "meaning": "Abundance stone—but real abundance isn't about more. It's about knowing you have enough. You ARE enough.",
      "color": "#FFA500"
    },
    "oil": {
      "name": "Patchouli",
      "meaning": "Earthy. Grounding. Reminds you that you're a human BEING, not a human DOING.",
      "color": "#4A3728"
    },
    "frequency": {
      "hz": 396,
      "name": "Root Frequency",
      "description": "Anchors you to your inherent worth. Not earned worth. Birthright worth."
    },
    "practice": {
      "type": "Somatic Anchor",
      "title": "Lengthen Your Exhale",
      "description": "Lengthen your exhale longer than your inhale twice daily. This activates your parasympathetic nervous system and brings calm.",
      "practices": [
        "Inhale for 4 seconds",
        "Hold your breath for 7 seconds",
        "Exhale for 8 seconds",
        "Practice twice daily"
      ]
    },
    "image": "https://images.unsplash.com/photo-1760011627103-00dca27188e3?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 9,
    "date": "May 19, 2026",
    "title": "The Voices",
    "theme": "Not Every Thought In Your Head Is Yours. Some Are Lies You Inherited.",
    "cosmic": "Gemini season begins—the sign of the mind, of thoughts, of inner dialogue. Time to audit which voices are actually yours and which were programmed into you by people who were wrong.",
    "exercise": "Write down the meanest thing you say to yourself regularly. Now ask: Whose voice is that really? A parent? A teacher? An ex? Write next to it: 'This is not my voice. I'm giving it back.'",
    "affirmation": "I get to choose which thoughts I believe. And I choose the ones that build me up.",
    "crystal": {
      "name": "Sodalite",
      "meaning": "Stone of truth. Helps you distinguish between your authentic voice and the noise. You've been listening to noise. Time for signal.",
      "color": "#2F4F7F"
    },
    "oil": {
      "name": "Rosemary",
      "meaning": "Clarity. Memory. But sometimes clarity means remembering who you were before the world told you who to be.",
      "color": "#4A6741"
    },
    "frequency": {
      "hz": 852,
      "name": "Intuition Frequency",
      "description": "Opens your third eye to see through the lies. Including the lies about yourself."
    },
    "practice": {
      "type": "Cognitive Tool",
      "title": "Two Things Can Be True",
      "description": "Two things can be true at once. Consider giving things opportunities to exist. One does not discount the other.",
      "practices": [
        "I can feel hurt AND maybe it wasn't intentional",
        "I can be having a great time AND my friend is barely tolerating",
        "The 2nd born child can be a miracle for the parents AND the worst day ever for the 1st born",
        "I can feel pain AND joy"
      ]
    },
    "image": "https://images.unsplash.com/photo-1748012906249-37245d620d1c?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 10,
    "date": "May 26, 2026",
    "title": "The Impossible",
    "theme": "Your 'Unrealistic' Dream Is Only Unrealistic Because No One Like You Has Done It Yet.",
    "cosmic": "Blue Moon rises—something that only happens every 2-3 years. Rare. Like you. Like your dreams. The impossible is just the possible that hasn't been proven yet.",
    "exercise": "Write down the dream you've never told anyone because it sounds too crazy. Read it out loud. To the sky. To the moon. To the universe that put that dream in you for a reason. It wasn't a mistake.",
    "affirmation": "My impossible dream is possible. I am the first. I am the proof.",
    "crystal": {
      "name": "Lapis Lazuli",
      "meaning": "The stone of royalty. Cleopatra wore it. You are descended from people who survived impossible things. You can do impossible things.",
      "color": "#26619C"
    },
    "oil": {
      "name": "Blue Tansy",
      "meaning": "Rare. Precious. Expensive. Like your dreams. Treat them accordingly.",
      "color": "#003366"
    },
    "frequency": {
      "hz": 963,
      "name": "Crown Chakra Frequency",
      "description": "Connects you to infinite possibility. Because your crown is where your connection to the divine lives."
    },
    "practice": {
      "type": "Micro-Courage",
      "title": "One Honest Thing",
      "description": "Say one honest thing kindly. To self or to other...even better to both you and other.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1640037984424-ac1a02cb742a?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 11,
    "date": "June 2, 2026",
    "title": "The Contradiction",
    "theme": "You Can Be Healing And Hurting At The Same Time. Both Are True.",
    "cosmic": "Gemini energy holds duality. The twins. You can be brave and scared. Strong and soft. Healing and broken. You don't have to pick one. You get to be the full complicated mess.",
    "exercise": "Write a conversation between two parts of yourself that seem to contradict each other. Let them both speak. Neither is lying. Both are you. Both deserve to be heard.",
    "affirmation": "I am not contradicting myself. I am containing multitudes. That's not confusion. That's depth.",
    "crystal": {
      "name": "Tiger's Eye",
      "meaning": "Balances seemingly opposite forces. Reminds you that contradiction isn't weakness—it's complexity. And complexity is interesting.",
      "color": "#C9A030"
    },
    "oil": {
      "name": "Basil",
      "meaning": "Integration. Helping the scattered parts come home to each other. You're not broken into pieces. You're faceted.",
      "color": "#3D5A28"
    },
    "frequency": {
      "hz": 639,
      "name": "Balance Frequency",
      "description": "Harmonizes opposing forces. Inside you. Around you. Between you and others."
    },
    "practice": {
      "type": "Micro-Courage",
      "title": "Where Are You Waiting for Permission?",
      "description": "Where are you waiting for permission you do not need? This is left over from childhood likely. You can decide now. This takes practice...you are the guide of your future now. Your parents did their job...they kept you alive. It's your turn now! Live...decide...do it! Accept the positive and negative consequences to everything and anything. This is your life now.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1621865098497-689d8591d93d?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 12,
    "date": "June 9, 2026",
    "title": "Venus-Jupiter Blessing",
    "theme": "Beauty & Abundance",
    "cosmic": "Venus and Jupiter conjunction on June 8-9! The two 'benefic' planets meet, showering blessings of love and abundance. Receive graciously.",
    "exercise": "Mirror work: Look into your own eyes for 2 minutes. Say aloud: 'I see you. I love you. You are beautiful exactly as you are.' Stay even if uncomfortable.",
    "affirmation": "I am worthy of beauty, love, and abundance. I receive graciously.",
    "crystal": {
      "name": "Rhodonite",
      "meaning": "Stone of self-worth and emotional healing. Helps you see your own value clearly.",
      "color": "#E75480"
    },
    "oil": {
      "name": "Bergamot",
      "meaning": "Uplifting citrus that builds self-confidence and releases self-judgment.",
      "color": "#8DB600"
    },
    "frequency": {
      "hz": 639,
      "name": "Heart Frequency",
      "description": "Opens the heart to self-love and receiving abundance."
    },
    "practice": {
      "type": "Integration Prompt",
      "title": "What Pattern Is Repeating?",
      "description": "What pattern is repeating this month? Sometimes leaning into 'the concept of' can be helpful. Either a state you enter, a feeling, thought pattern. The situation often LOOKS different, consider looking upon like it's art...a concept. Different literal STORIES can create the same THEME within. Feeling frustration, trapped, dismissed, overlooked etc etc.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1761394196125-5b2ca434f328?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 13,
    "date": "June 16, 2026",
    "title": "Summer Solstice Approaches",
    "theme": "Peak Light",
    "cosmic": "Summer Solstice (June 20th) brings the longest day. Cancer season begins. Maximum light, maximum growth. Honor the sun's peak power.",
    "exercise": "Wake at sunrise (or watch a sunrise video). Stand with arms wide, receiving the light. Thank the sun for sustaining all life. You are part of this cycle.",
    "affirmation": "I honor the light within and around me. I am at my peak.",
    "crystal": {
      "name": "Sunstone",
      "meaning": "Captures the sun's energy. Brings joy, vitality, and leadership qualities.",
      "color": "#FF6B35"
    },
    "oil": {
      "name": "Orange",
      "meaning": "Pure sunshine in a bottle. Uplifts mood and promotes joy and creativity.",
      "color": "#FF8C00"
    },
    "frequency": {
      "hz": 528,
      "name": "Solar Frequency",
      "description": "The frequency of the sun—transformation, DNA repair, and awakening."
    },
    "practice": {
      "type": "Emotional Barometer",
      "title": "Is This Intensity Mine or Borrowed?",
      "description": "We may be influenced by something that is not ours. Not ours to carry, not our pain. Perhaps we listened to a friend today telling us something difficult, a pain. And we later notice our own heaviness for no reason within our own life. Perhaps we are carrying this pain. It's lovely to listen, to share our ears. Shed what is not ours. We are not serving that person by carrying this, nor are we serving self. If we are able to notice these moments...perhaps a new viewpoint arrives.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1729277133101-54990c9c2ae7?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 14,
    "date": "June 23, 2026",
    "title": "Cancer's Nurturing",
    "theme": "Home & Emotional Safety",
    "cosmic": "Cancer season is here. The Crab asks: What does home mean to you? How do you nurture yourself? Create emotional safety from within.",
    "exercise": "Create a 'safe space' visualization: Imagine a room that's perfectly yours—colors, textures, scents, sounds. Visit it whenever you need comfort.",
    "affirmation": "I carry home within me. I am safe, wherever I am.",
    "crystal": {
      "name": "Moonstone",
      "meaning": "Reflects the moon's intuitive energy. Enhances emotional clarity and new beginnings.",
      "color": "#F0F0F0"
    },
    "oil": {
      "name": "Sweet Marjoram",
      "meaning": "Comforting and warm. Eases emotional pain and creates a sense of safety.",
      "color": "#9ACD32"
    },
    "frequency": {
      "hz": 174,
      "name": "Security Frequency",
      "description": "The foundation frequency—reduces pain and creates a sense of safety."
    },
    "practice": {
      "type": "Loop Interrupter",
      "title": "The 90-Second Delay",
      "description": "Delay response to charged messages by 90 seconds. Better yet, a sleep, a walk, a mini adventure. If we can remind ourselves of 90 seconds!",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1624186639059-30c2bb39c406?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 15,
    "date": "June 30, 2026",
    "title": "Jupiter Enters Leo",
    "theme": "Expansion & Expression",
    "cosmic": "Jupiter enters Leo on June 30th! The planet of expansion meets the sign of creative self-expression. A year of bold growth begins. Dream bigger!",
    "exercise": "What would you do if you knew you couldn't fail? Write it down. Jupiter in Leo says: You CAN'T fail when you're being authentically yourself.",
    "affirmation": "I expand into my fullest self. My authentic expression is my gift to the world.",
    "crystal": {
      "name": "Orange Calcite",
      "meaning": "Stone of creativity and confidence. Activates your sacral chakra and encourages bold self-expression.",
      "color": "#FF7F00"
    },
    "oil": {
      "name": "Frankincense",
      "meaning": "The king of oils for spiritual expansion. Elevates meditation and self-expression.",
      "color": "#D4A574"
    },
    "frequency": {
      "hz": 417,
      "name": "Creativity Frequency",
      "description": "Facilitates change and enhances creative expression."
    },
    "practice": {
      "type": "Somatic Anchor",
      "title": "Drop Your Shoulders Before Speaking",
      "description": "Drop your shoulders before speaking. Take a big breath in and raise shoulders up up up, and then allow to fall with exhale. Repeat 3 or more times. One big breath and go!",
      "practices": [
        "Take a big breath in",
        "Raise shoulders up up up",
        "Allow to fall with exhale",
        "Repeat 3 or more times",
        "One big breath and go!"
      ]
    },
    "image": "https://images.unsplash.com/photo-1600181718409-9fe89f2a6fce?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 16,
    "date": "July 7, 2026",
    "title": "Mercury Retrograde Returns",
    "theme": "Reflection & Patience",
    "cosmic": "Mercury Retrograde in Cancer begins June 29th. Neptune also goes retrograde July 7th. Time to slow down, review, reflect. Communication may get hazy—practice patience.",
    "exercise": "Do a 'digital sunset'—no screens for the last hour before bed. Use that time for gentle stretching, journaling, or simply being. Let your mind rest.",
    "affirmation": "I embrace the pause. In stillness, wisdom speaks.",
    "crystal": {
      "name": "Aquamarine",
      "meaning": "Stone of calm waters and clear communication. Especially helpful during Mercury retrograde.",
      "color": "#7FFFD4"
    },
    "oil": {
      "name": "Chamomile",
      "meaning": "Soothing and patience-inducing. Perfect for navigating retrograde frustrations.",
      "color": "#F5F5DC"
    },
    "frequency": {
      "hz": 432,
      "name": "Universal Frequency",
      "description": "The 'heartbeat of the planet'—brings deep calm and natural harmony."
    },
    "practice": {
      "type": "Cognitive Tool",
      "title": "Confidence Does Not Require Dominance",
      "description": "Have you heard the expression...A lion does not need to tell the jungle it's a lion? Usually the 'posturing' lion...is not the dominant. The dominant sits quietly. Never needing to apologize or announce himself. This sort of internal confidence comes with practice, healing, knowing ourselves more deeply. I firmly believe we must heal how we support ourselves in the background of our minds. Retrain our mind towards the supportive parent/voice we always needed/wanted. Healing deeper wounding may be especially useful in the area of confidence.",
      "practices": [
        "If your best friend came to you feeling low...what would you tell this friend you liked about them?",
        "What might your best friend tell you?",
        "What might you as your best friend want to tell yourself?",
        "Place a chair in front of you, pick an age of yourself (future or even past)",
        "Write that age on a piece of paper and place it in the chair",
        "Sit back and forth between the 2 chairs having a heart-to-heart chat"
      ]
    },
    "image": "https://images.unsplash.com/photo-1739508078421-8f036262e64a?w=1200&q=80",
    "imagePos": "bottom"
  },
  {
    "n": 17,
    "date": "July 14, 2026",
    "title": "New Moon in Cancer",
    "theme": "Emotional New Beginnings",
    "cosmic": "New Moon in Cancer on July 14th. Plant seeds for emotional healing and family harmony. What patterns do you want to break?",
    "exercise": "Write a letter to your inner child. Tell them what you wish someone had said to you then. Be the parent you needed. Read it aloud to yourself.",
    "affirmation": "I heal my past by loving my present. My inner child is safe with me.",
    "crystal": {
      "name": "Chrysocolla",
      "meaning": "Stone of goddess energy and emotional healing. Soothes heartache and empowers gentle strength.",
      "color": "#20B2AA"
    },
    "oil": {
      "name": "Roman Chamomile",
      "meaning": "The 'mother's oil'—nurturing, soothing, healing childhood wounds.",
      "color": "#E6E6FA"
    },
    "frequency": {
      "hz": 396,
      "name": "Liberation Frequency",
      "description": "Releases grief, fear, and emotional blocks from the past."
    },
    "practice": {
      "type": "Micro-Courage",
      "title": "One Action Aligned with Your Values",
      "description": "Take one action aligned with your values, quietly. What are your values? Consider: Authenticity, Compassion, Curiosity, Growth, Inner Harmony, Kindness, Meaningful Work, Peace, Self-Respect, Spirituality, Wisdom...",
      "practices": [
        "Authenticity, Achievement, Adventure, Autonomy, Balance",
        "Beauty, Boldness, Compassion, Challenge, Community",
        "Creativity, Curiosity, Determination, Fairness, Faith",
        "Friendships, Fun, Growth, Happiness, Honesty, Humor",
        "Inner Harmony, Justice, Kindness, Knowledge, Love, Loyalty",
        "Meaningful Work, Openness, Optimism, Peace, Self-Respect",
        "Spirituality, Stability, Trustworthiness, Wealth, Wisdom"
      ]
    },
    "image": "https://images.unsplash.com/photo-1571038236508-35ca24d184bb?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 18,
    "date": "July 21, 2026",
    "title": "Leo Season Roars",
    "theme": "Courage & Self-Expression",
    "cosmic": "Sun enters Leo on July 22nd. Mercury goes direct on July 23rd! The Lion roars with creative power. Step into your spotlight.",
    "exercise": "Do something that scares you (safely)—speak up, create something, share your work. Feel the fear. Do it anyway. That's courage.",
    "affirmation": "I am worthy of being seen. My light is meant to shine.",
    "crystal": {
      "name": "Carnelian",
      "meaning": "Stone of courage and creativity. Ignites your inner fire and helps you perform.",
      "color": "#B31B1B"
    },
    "oil": {
      "name": "Cinnamon",
      "meaning": "Warming and empowering. Builds courage and attracts success.",
      "color": "#D2691E"
    },
    "frequency": {
      "hz": 417,
      "name": "Courage Frequency",
      "description": "Facilitates change and enhances creative expression."
    },
    "practice": {
      "type": "Discernment Filter",
      "title": "Clarity or Compulsion?",
      "description": "Am I engaging this out of clarity or compulsion? Compulsion typically arrives with anxiety, impatience and various other slightly disruptive energies. Clarity often resembles smoothness, calmness, quiet excitement perhaps.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1545141416-83ebe371f66e?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 19,
    "date": "July 28, 2026",
    "title": "Saturn Retrograde",
    "theme": "Discipline Review",
    "cosmic": "Saturn goes retrograde in Aries on July 26th. Review your structures and commitments. What disciplines serve you? What constraints can you release?",
    "exercise": "Audit your routines: List everything you do daily/weekly. Mark what energizes you (+) and what drains you (-). Can you shift one (-) to a (+)?",
    "affirmation": "I embrace discipline as an act of self-love. Structure sets me free.",
    "crystal": {
      "name": "Garnet",
      "meaning": "Stone of commitment and passion. Helps you stay dedicated to what truly matters.",
      "color": "#722F37"
    },
    "oil": {
      "name": "Cedarwood",
      "meaning": "Grounding and strengthening. Used for focus and perseverance.",
      "color": "#5D432C"
    },
    "frequency": {
      "hz": 396,
      "name": "Root Frequency",
      "description": "Grounds you while releasing what no longer serves."
    },
    "practice": {
      "type": "Emotional Barometer",
      "title": "What Is Underneath the Loudest Emotion?",
      "description": "Some emotions are disguised by other emotions. Let's say 'safer' emotions come to the surface, more vulnerable ones hide. I was stuck in Betrayal for a long time. Then something came to me...that betrayal HIDES feeling forgotten. And boom! That was it. I shifted nearly immediately after a really good cry. 4 years of pain...poof...once I processed the REAL emotion. Be open to what may be just below the surface and with a little curiosity it may reveal.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1704866524828-456c33fc7411?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 20,
    "date": "August 4, 2026",
    "title": "Lion's Gate Portal",
    "theme": "Cosmic Downloads",
    "cosmic": "Lion's Gate Portal peaks on August 8th (8/8). The star Sirius aligns with Earth and Orion's Belt. Ancient Egyptians marked this as the spiritual new year. Powerful manifestation energy!",
    "exercise": "At 8:08 (AM or PM), sit in meditation. Visualize a column of light descending from Sirius into your crown. Receive whatever messages come. Trust them.",
    "affirmation": "I am open to cosmic wisdom. The universe speaks and I listen.",
    "crystal": {
      "name": "Celestite",
      "meaning": "Stone of angels and cosmic communication. Opens channels to higher guidance.",
      "color": "#ADD8E6"
    },
    "oil": {
      "name": "Frankincense",
      "meaning": "The king of oils for spiritual connection. Egyptians used it during Sirius rising ceremonies.",
      "color": "#D4A574"
    },
    "frequency": {
      "hz": 963,
      "name": "Divine Frequency",
      "description": "Activates the pineal gland and opens you to cosmic downloads."
    },
    "practice": {
      "type": "Somatic Anchor",
      "title": "Slow Your Body Before Seeking Explanation",
      "description": "When surprised, slow your body before seeking explanation. Take a breath, a moment. In a predictable moment...close your eyes. Sit with your body for a moment and recall a time when SURPRISE came along? Where did it show up in your body? Good surprise vs not so good surprise. They will be different and show up differently. This exercise will help facilitate another moment and maybe catch you less off guard.",
      "practices": [
        "Close your eyes in a predictable moment",
        "Recall a time when SURPRISE came along",
        "Where did it show up in your body?",
        "Good surprise vs not so good surprise - they show up differently",
        "This helps you identify the interactions of life, emotions and body living"
      ]
    },
    "image": "https://images.unsplash.com/photo-1543330532-1f89a87dce33?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 21,
    "date": "August 11, 2026",
    "title": "Solar Eclipse in Leo",
    "theme": "Identity Transformation",
    "cosmic": "Solar Eclipse in Leo on August 12th! Eclipses accelerate fate—major shifts are possible. This one transforms how you see yourself and express your identity.",
    "exercise": "Ask: 'Who was I one year ago? Who am I becoming?' Write freely for 10 minutes. Don't edit—let truth emerge through the pen.",
    "affirmation": "I release old identities with gratitude. I step into who I am becoming.",
    "crystal": {
      "name": "Golden Healer Quartz",
      "meaning": "Master healer for the soul. Helps you shed old identities and step into your golden self.",
      "color": "#FFD700"
    },
    "oil": {
      "name": "Helichrysum",
      "meaning": "Called 'Immortelle'—for immortal transformation. Heals emotional wounds at the deepest level.",
      "color": "#DAA520"
    },
    "frequency": {
      "hz": 528,
      "name": "Transformation Frequency",
      "description": "The miracle tone for profound personal transformation."
    },
    "practice": {
      "type": "Loop Interrupter",
      "title": "Stand Up Mid-Scroll",
      "description": "Stand up mid-scroll. Just do it! See what happens. DO IT!",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1701957425349-204c2c40b3ac?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 22,
    "date": "August 18, 2026",
    "title": "Virgo Season Begins",
    "theme": "Sacred Service",
    "cosmic": "Sun enters Virgo on August 22nd. The Virgin represents sacred service—not servitude. How can you serve from overflow, not depletion?",
    "exercise": "Perform one act of service today with complete presence. Not to be praised—just to serve. Notice how giving freely fills your own cup.",
    "affirmation": "I serve from abundance. My service is an act of love, not obligation.",
    "crystal": {
      "name": "Amazonite",
      "meaning": "Stone of truth and healthy boundaries. Helps you serve without losing yourself.",
      "color": "#00FFEF"
    },
    "oil": {
      "name": "Tea Tree",
      "meaning": "Purifying and protective. Cleanses energy so you can serve from a clear, healthy place.",
      "color": "#C9E4CA"
    },
    "frequency": {
      "hz": 741,
      "name": "Purification Frequency",
      "description": "Cleanses toxins and helps you serve from a pure place."
    },
    "practice": {
      "type": "Emotional Barometer",
      "title": "Notice Subtle Stress Before It Escalates",
      "description": "Almost like our hunger, we tend to dismiss it and put it off. But by the time we are hungry...we are truly over hungry. Same happens with stress, subtle at first, even the subtle means our cup runneth over.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1701957425156-5a178fd046a3?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 23,
    "date": "August 25, 2026",
    "title": "Lunar Eclipse in Pisces",
    "theme": "Spiritual Completion",
    "cosmic": "Lunar Eclipse in Pisces on August 27th. What spiritual journey is completing? Pisces ends the zodiac—honor what you've learned before moving forward.",
    "exercise": "Create a 'completion ritual': Light a candle. Speak aloud what you're grateful for from this chapter. Blow out the candle. A chapter closes so a new one can begin.",
    "affirmation": "I honor endings as sacred. I complete with grace and gratitude.",
    "crystal": {
      "name": "Ametrine",
      "meaning": "Combines Amethyst and Citrine—spiritual completion meets new manifestation.",
      "color": "#9966CC"
    },
    "oil": {
      "name": "Sandalwood",
      "meaning": "Sacred oil of completion and meditation. Used in end-of-life rituals and spiritual transitions.",
      "color": "#C2B280"
    },
    "frequency": {
      "hz": 963,
      "name": "Completion Frequency",
      "description": "Connects you to divine wholeness and spiritual completion."
    },
    "practice": {
      "type": "Cognitive Tool",
      "title": "Uncertainty Does Not Equal Danger",
      "description": "Uncertainty does not equal danger.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1695130152293-0f839a0c2cbf?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 24,
    "date": "September 1, 2026",
    "title": "Harvest Approaches",
    "theme": "Reaping What You've Sown",
    "cosmic": "Deep in Virgo season—time to harvest. Look back at your Week 1 intentions from the Spring Equinox. What has grown? Assess without judgment.",
    "exercise": "Review your Week 1 intentions. Without criticism, note: What grew? What didn't? What surprised you? Harvest data, not shame.",
    "affirmation": "I reap my harvest with gratitude. Every outcome teaches me.",
    "crystal": {
      "name": "Citrine",
      "meaning": "Stone of abundance and manifestation. Celebrates your harvest and attracts more prosperity.",
      "color": "#FFA500"
    },
    "oil": {
      "name": "Cardamom",
      "meaning": "Warming spice of gratitude and celebration. Uplifts while grounding you in appreciation.",
      "color": "#9ACD32"
    },
    "frequency": {
      "hz": 528,
      "name": "Abundance Frequency",
      "description": "The miracle tone—celebrate your growth and transformations."
    },
    "practice": {
      "type": "Integration Prompt",
      "title": "What Strengthened You This Summer?",
      "description": "What strengthened you this summer?",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1773394473042-0544a86abe61?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 25,
    "date": "September 8, 2026",
    "title": "New Moon in Virgo",
    "theme": "Health & Wellness Intentions",
    "cosmic": "New Moon in Virgo on September 10th. Uranus goes retrograde in Gemini. Set intentions for health, routines, and practical improvements.",
    "exercise": "Choose ONE health upgrade for the next month. Just one—small and sustainable. Write it down. Commit. Begin tomorrow.",
    "affirmation": "I honor my body as sacred ground. Small steps create lasting change.",
    "crystal": {
      "name": "Green Jade",
      "meaning": "Stone of health and longevity. Attracts good fortune and supports physical vitality.",
      "color": "#00A86B"
    },
    "oil": {
      "name": "Juniper Berry",
      "meaning": "Detoxifying and purifying. Supports the body's natural cleansing processes.",
      "color": "#3D5A28"
    },
    "frequency": {
      "hz": 285,
      "name": "Healing Frequency",
      "description": "Promotes tissue regeneration and physical healing."
    },
    "practice": {
      "type": "Somatic Anchor",
      "title": "Schedule Rest Before Exhaustion Does",
      "description": "Schedule rest before exhaustion schedules it for you.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1770546025492-cbbd01700768?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 26,
    "date": "September 15, 2026",
    "title": "Autumn Equinox",
    "theme": "Balance & Reflection",
    "cosmic": "Autumn Equinox on September 22nd. Equal day and night—find equilibrium. Libra season begins. You're halfway through your 52-week journey!",
    "exercise": "Draw a line down a page. On one side: what's working. On the other: what's not. Look at both with equal love. Balance isn't perfect—it's aware.",
    "affirmation": "I embrace both light and shadow. In balance, I find wholeness.",
    "crystal": {
      "name": "Black Moonstone",
      "meaning": "Balances masculine and feminine, light and dark. Perfect for equinox energy.",
      "color": "#2F4F4F"
    },
    "oil": {
      "name": "Geranium",
      "meaning": "The balancer. Harmonizes emotions and helps you find equilibrium in all things.",
      "color": "#C73E3A"
    },
    "frequency": {
      "hz": 639,
      "name": "Harmony Frequency",
      "description": "Creates balance in relationships and within yourself."
    },
    "practice": {
      "type": "Discernment Filter",
      "title": "Is This Useful or Just Stimulating?",
      "description": "Is this useful or just stimulating?",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1764531012704-35c20e92edf1?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 27,
    "date": "September 22, 2026",
    "title": "Libra's Scales",
    "theme": "Justice & Relationships",
    "cosmic": "Full Libra season. The Scales ask: Where are you giving too much or too little? Justice starts with self-honesty in relationships.",
    "exercise": "Think of one relationship that feels unbalanced. Without blame, ask: What boundary could restore balance? Sometimes the boundary is with yourself.",
    "affirmation": "I seek balance in all my relationships. I give and receive equally.",
    "crystal": {
      "name": "Lepidolite",
      "meaning": "Stone of transition and balance. Contains lithium for natural emotional stabilization.",
      "color": "#9966CC"
    },
    "oil": {
      "name": "Clary Sage",
      "meaning": "Brings clarity to emotional confusion. Helps you see relationships clearly.",
      "color": "#87A96B"
    },
    "frequency": {
      "hz": 639,
      "name": "Relationship Frequency",
      "description": "Heals and harmonizes all types of relationships."
    },
    "practice": {
      "type": "Cognitive Tool",
      "title": "Criticism Can Refine Without Defining You",
      "description": "Criticism can refine without defining you.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1630861410629-d136eb970587?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 28,
    "date": "September 29, 2026",
    "title": "Venus Retrograde Begins",
    "theme": "Revisiting Love & Values",
    "cosmic": "Venus goes retrograde in Scorpio on October 3rd. Old loves, old values, old wounds around worth may resurface. This is healing, not haunting.",
    "exercise": "Write a gratitude letter to a past relationship (romantic, friendship, or family). Even painful ones taught you. You don't have to send it—just acknowledge.",
    "affirmation": "I honor all my relationships as teachers. I release what I've learned from.",
    "crystal": {
      "name": "Malachite",
      "meaning": "Stone of transformation and heart healing. Helps you process old relationship wounds.",
      "color": "#0BDA51"
    },
    "oil": {
      "name": "Rose Absolute",
      "meaning": "Deep heart healer. Opens old wounds with love so they can finally close.",
      "color": "#FF007F"
    },
    "frequency": {
      "hz": 639,
      "name": "Heart Healing Frequency",
      "description": "Heals relationship wounds and opens the heart to new love."
    },
    "practice": {
      "type": "Micro-Courage",
      "title": "Close One Unfinished Loop",
      "description": "Close one unfinished loop.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1580337226979-f0b9733a8446?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 29,
    "date": "October 6, 2026",
    "title": "Hunter's Moon Rising",
    "theme": "Pursuing What Matters",
    "cosmic": "New Moon in Libra on October 10th. Hunter's Moon (Full Moon) on October 26th approaches. What are you hunting? Pursue only what truly matters.",
    "exercise": "Prioritize ruthlessly: List everything demanding your energy. Circle only 3 that truly matter. The rest? Delegate, delete, or delay.",
    "affirmation": "I pursue only what aligns with my soul. My energy is sacred.",
    "crystal": {
      "name": "Red Jasper",
      "meaning": "Stone of endurance and focus. Helps you pursue your goals with sustained energy.",
      "color": "#A52A2A"
    },
    "oil": {
      "name": "Black Pepper",
      "meaning": "Stimulating and motivating. Helps you push through resistance toward your goals.",
      "color": "#2F2F2F"
    },
    "frequency": {
      "hz": 396,
      "name": "Focus Frequency",
      "description": "Liberates from distraction and helps you pursue what matters."
    },
    "practice": {
      "type": "Discernment Filter",
      "title": "Engage Without Surrendering Discernment",
      "description": "Engage the future without surrendering your discernment. Notice blind trust for comfort, notice where you shut down or turn to 'the easy answers' — they may not FEEL right for you.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1636501034642-7b60be346588?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 30,
    "date": "October 13, 2026",
    "title": "Pluto Direct",
    "theme": "Deep Transformation",
    "cosmic": "Pluto goes direct on October 15th after months retrograde. Deep transformation that was processing internally now moves forward. What's been transforming in your depths?",
    "exercise": "Shadow prompt: Complete this sentence 10 times without thinking: 'I don't want anyone to know that I...' Review with compassion. These shadows need light.",
    "affirmation": "I descend into my depths with courage. In darkness, I find treasure.",
    "crystal": {
      "name": "Black Obsidian",
      "meaning": "Ultimate shadow work stone. Reveals hidden truths with protective energy.",
      "color": "#0B0B0B"
    },
    "oil": {
      "name": "Vetiver",
      "meaning": "Grounding during deep psychological work. Keeps you anchored while exploring shadow.",
      "color": "#3D2B1F"
    },
    "frequency": {
      "hz": 396,
      "name": "Shadow Frequency",
      "description": "Liberates from fear and guilt, transforming shadow into light."
    },
    "practice": {
      "type": "Cognitive Tool",
      "title": "Pause Before Agreeing Publicly",
      "description": "Pause before agreeing publicly.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1602955585779-92b0d4a2c3b0?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 31,
    "date": "October 20, 2026",
    "title": "Scorpio Season",
    "theme": "Intensity & Intimacy",
    "cosmic": "Sun enters Scorpio on October 22nd. The Scorpion invites you into the underworld—not to stay, but to transform. Face what you've avoided.",
    "exercise": "What are you avoiding? Name it. Write it down. Now ask: What's the worst that could happen if I faced it? Usually, avoidance is worse than the thing itself.",
    "affirmation": "I face my fears with courage. On the other side of fear is freedom.",
    "crystal": {
      "name": "Smoky Quartz",
      "meaning": "Transmutes negative energy. Helps you face difficult emotions without being overwhelmed.",
      "color": "#4A3728"
    },
    "oil": {
      "name": "Myrrh",
      "meaning": "Ancient oil of spiritual truth. Used in sacred rituals for deep seeing.",
      "color": "#704214"
    },
    "frequency": {
      "hz": 852,
      "name": "Clarity Frequency",
      "description": "Awakens intuition and helps you see through illusion."
    },
    "practice": {
      "type": "Emotional Barometer",
      "title": "Tone or Substance?",
      "description": "Are you reacting to tone or substance?",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1760783320351-6a7ae1772b68?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 32,
    "date": "October 27, 2026",
    "title": "Mercury Retrograde Returns",
    "theme": "Final Review",
    "cosmic": "Mercury Retrograde in Scorpio begins October 24th—the year's final retrograde. Review, revise, and release. What's incomplete before year's end?",
    "exercise": "Do a 'life audit' for 2026. Review each area: health, relationships, work, spirit. Rate 1-10. No judgment—just awareness. What needs attention?",
    "affirmation": "I review my life with honesty and love. What's incomplete becomes complete.",
    "crystal": {
      "name": "Labradorite",
      "meaning": "Stone of magic and protection during transformation. Shields during intense retrograde energy.",
      "color": "#1E3A5F"
    },
    "oil": {
      "name": "Frankincense",
      "meaning": "The oil of sacred review. Used in ancient rituals for reflection and clarity.",
      "color": "#D4A574"
    },
    "frequency": {
      "hz": 852,
      "name": "Review Frequency",
      "description": "Awakens intuition and helps you see your year clearly."
    },
    "practice": {
      "type": "Loop Interrupter",
      "title": "Breathe Before You Post",
      "description": "Breathe before you post.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1729277133093-5915b9b18c9c?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 33,
    "date": "November 3, 2026",
    "title": "Samhain / Day of Dead",
    "theme": "Honoring Ancestors",
    "cosmic": "The veil between worlds thins around October 31st - November 2nd. Ancient cultures honored ancestors now. Who came before you? What wisdom do they hold?",
    "exercise": "Create a simple ancestor altar: a photo, a candle, something they loved. Sit with it. Talk to them. Listen. The dead have much to teach.",
    "affirmation": "I stand on the shoulders of my ancestors. Their wisdom flows through me.",
    "crystal": {
      "name": "Apache Tear",
      "meaning": "Grief stone that connects to ancestors. Helps process loss while maintaining connection.",
      "color": "#2F2F2F"
    },
    "oil": {
      "name": "Cypress",
      "meaning": "Oil of transitions and honoring the dead. Used in ancient funerary rites.",
      "color": "#234F1E"
    },
    "frequency": {
      "hz": 174,
      "name": "Ancestral Frequency",
      "description": "The lowest, most grounding tone—connects you to those who came before."
    },
    "practice": {
      "type": "Emotional Barometer",
      "title": "Disappointment Is Not Identity",
      "description": "Disappointment can be processed without becoming identity.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1701964393279-29980cac7459?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 34,
    "date": "November 10, 2026",
    "title": "11:11 Gateway",
    "theme": "Manifestation Portal",
    "cosmic": "11/11 is a powerful manifestation portal. Venus and Mercury both go direct by November 13th—energy clears for forward movement.",
    "exercise": "At 11:11 (AM and PM), pause. Close your eyes. State one clear intention as if it's already true. Feel it in your body. Thank the universe. Move on.",
    "affirmation": "I am a powerful manifestor. My intentions become reality.",
    "crystal": {
      "name": "Phenacite",
      "meaning": "One of the highest vibration stones. Opens crown chakra for direct manifestation.",
      "color": "#F0F0F0"
    },
    "oil": {
      "name": "Bay Laurel",
      "meaning": "Victory and achievement. Ancient champions were crowned with laurel.",
      "color": "#5F8A3F"
    },
    "frequency": {
      "hz": 963,
      "name": "Manifestation Frequency",
      "description": "The highest frequency—direct connection to manifestation power."
    },
    "practice": {
      "type": "Integration Prompt",
      "title": "What Belief Shifted This Month?",
      "description": "What belief shifted this month?",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1701956532935-9ff0dce53c31?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 35,
    "date": "November 17, 2026",
    "title": "Sagittarius Season",
    "theme": "Expansion & Adventure",
    "cosmic": "Sun enters Sagittarius on November 21st. The Archer aims high and far. After Scorpio's depths, now expand your horizons. Dream bigger.",
    "exercise": "Plan one adventure—big or small. A trip, a class, a new experience. Something that expands your world. Write it down. Commit.",
    "affirmation": "I aim high and trust my arrow will fly true. Adventure awaits.",
    "crystal": {
      "name": "Blue Topaz",
      "meaning": "Stone of truth and expansion. Helps you speak your truth and expand your horizons.",
      "color": "#0F52BA"
    },
    "oil": {
      "name": "Grapefruit",
      "meaning": "Uplifting and optimistic. Promotes adventure and positive outlook.",
      "color": "#FF6347"
    },
    "frequency": {
      "hz": 852,
      "name": "Expansion Frequency",
      "description": "Opens intuition and expands consciousness."
    },
    "practice": {
      "type": "Somatic Anchor",
      "title": "Ground Before Seeking Meaning",
      "description": "Ground your body before seeking meaning. We often seek meaning where there may not be meaning. Ground first — breaths, plant feet, laugh, pinch self — anything to bring a sense of calmness. Then ask: why do I seek meaning? Does this have meaning? Am I seeking comfort over meaning?",
      "practices": [
        "Take deep breaths",
        "Plant your feet firmly on the ground",
        "Laugh, pinch yourself — anything to arrive in the body",
        "Then ask: why do I seek meaning here?",
        "Does this truly have meaning, or am I seeking comfort?"
      ]
    },
    "image": "https://images.unsplash.com/photo-1643905962434-d8c5ff07f4df?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 36,
    "date": "November 24, 2026",
    "title": "Gratitude Moon",
    "theme": "Deep Thanksgiving",
    "cosmic": "Beaver Moon (Full Moon) on November 24th. In North America, Thanksgiving brings collective gratitude energy. Ride this wave.",
    "exercise": "Gratitude flood: Set timer for 5 minutes. Write everything you're grateful for—don't stop writing. Big, small, obvious, hidden. Flood yourself with thanks.",
    "affirmation": "I am grateful for everything—the gifts and the lessons. All is blessing.",
    "crystal": {
      "name": "Chrysoprase",
      "meaning": "Stone of gratitude and abundance. Opens heart to see blessings everywhere.",
      "color": "#7FFF00"
    },
    "oil": {
      "name": "Copaiba",
      "meaning": "Deeply soothing and grounding. Creates a sense of warmth and abundance.",
      "color": "#C4A35A"
    },
    "frequency": {
      "hz": 528,
      "name": "Gratitude Frequency",
      "description": "The love frequency—amplifies feelings of gratitude and connection."
    },
    "practice": {
      "type": "Micro-Courage",
      "title": "Have the Grounded Conversation",
      "description": "Have the grounded conversation. Entertain the soul, the sacred, the grander topics of life, our existence, true purpose. Play with bigger, deeper conversations. What happens? For you and for other.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1500056465874-8cceb7570f0d?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 37,
    "date": "December 1, 2026",
    "title": "Preparing for Stillness",
    "theme": "Slowing Down",
    "cosmic": "As the year winds down, darkness increases. Honor the season by slowing down. Rest is productive. The earth is resting too.",
    "exercise": "Practice 'doing nothing' for 15 minutes. No phone, no book, no music. Just sit or lie down. Watch thoughts pass. This is not wasted time.",
    "affirmation": "I honor rest as sacred. In stillness, I am restored.",
    "crystal": {
      "name": "Blue Lace Agate",
      "meaning": "Calming stone for the nervous system. Helps you surrender to peaceful rest.",
      "color": "#ADD8E6"
    },
    "oil": {
      "name": "Valerian",
      "meaning": "Nature's sedative. Promotes deep rest and restorative sleep.",
      "color": "#9ACD32"
    },
    "frequency": {
      "hz": 174,
      "name": "Rest Frequency",
      "description": "The foundation frequency—promotes deep rest and recovery."
    },
    "practice": {
      "type": "Integration Prompt",
      "title": "Release Without Drama",
      "description": "What are you ready to release without drama?",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1519645480282-2bcc997ba3b0?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 38,
    "date": "December 8, 2026",
    "title": "Saturn & Neptune Direct",
    "theme": "Clarity Returns",
    "cosmic": "Saturn goes direct on December 10th, Neptune direct on December 12th. Structure and dreams both move forward. Clarity returns after months of review.",
    "exercise": "Revisit your mid-year confusions. What's clear now that wasn't then? Write down 3 insights that emerged from this year's fog.",
    "affirmation": "Clarity comes in divine timing. I trust the process of understanding.",
    "crystal": {
      "name": "Clear Calcite",
      "meaning": "Optical calcite doubles and clarifies light. Brings mental clarity and insight.",
      "color": "#F5F5F5"
    },
    "oil": {
      "name": "Peppermint",
      "meaning": "Mental clarity in a bottle. Clears brain fog and sharpens thinking.",
      "color": "#98FF98"
    },
    "frequency": {
      "hz": 852,
      "name": "Clarity Frequency",
      "description": "Opens the third eye and brings mental clarity."
    },
    "practice": {
      "type": "Cognitive Tool",
      "title": "Expansion Requires Structure",
      "description": "Expansion requires structure. Many years ago I watched a Tony Robbins video — his shortest! He listed 6 things we NEED. What's your target? What's your map? What's your fuel?",
      "practices": [
        "Certainty — you gotta know you're paying your bills",
        "Uncertainty — spontaneity! If we don't invite mystery and surprise into life, we have problems",
        "Significance — we need to feel significance. If we don't, we often turn to violence or victim mode. It's not your resources, it's about resourcefulness",
        "Love / Connection — intimacy, connection, love. You can find this anywhere: nature, animal, partner, hobby",
        "Grow / Contribution — contribution beyond self, giving something greater",
        "Emotion — there are more than 6,000 emotions. Most of us shuffle through 12. A few good ones and a bunch of negative ones!",
        "Know your own operating system. What do you value most — certainty or uncertainty? Significance or connection? Growth or emotions?"
      ]
    },
    "image": "https://images.unsplash.com/photo-1686083535866-528fcb469239?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 39,
    "date": "December 15, 2026",
    "title": "Winter Solstice Approaches",
    "theme": "Return of the Light",
    "cosmic": "Winter Solstice on December 21st—the longest night. Capricorn season begins. After this, light returns. Honor the darkness that births light.",
    "exercise": "Light a candle in the darkness. Watch the flame. Know that you carry this light within—a spark that no darkness can extinguish.",
    "affirmation": "Even in the longest night, I carry light. I am the dawn.",
    "crystal": {
      "name": "Snowflake Obsidian",
      "meaning": "Balance of dark (obsidian) and light (snowflakes). Perfect for solstice energy.",
      "color": "#2F2F2F"
    },
    "oil": {
      "name": "Spruce",
      "meaning": "The Christmas tree oil. Grounding while uplifting, connecting earth to sky.",
      "color": "#2E5A4C"
    },
    "frequency": {
      "hz": 528,
      "name": "Light Frequency",
      "description": "The miracle tone—transformation and the return of light."
    },
    "practice": {
      "type": "Emotional Barometer",
      "title": "Hardening Instead of Healing?",
      "description": "Where are you hardening instead of healing?",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1700864182167-a619bf74f46c?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 40,
    "date": "December 22, 2026",
    "title": "Cold Moon Rising",
    "theme": "Reflection & Release",
    "cosmic": "Cold Moon (Full Moon) on December 24th. The year's final Full Moon illuminates your journey. What a year it's been.",
    "exercise": "2026 in review: Month by month, recall one moment from each. Don't judge—just remember. Create a mental scrapbook of your year.",
    "affirmation": "I honor my journey through 2026. Every moment was necessary.",
    "crystal": {
      "name": "Shungite",
      "meaning": "Ancient carbon stone. Absorbs and neutralizes all that needs releasing.",
      "color": "#1A1A1A"
    },
    "oil": {
      "name": "Juniper",
      "meaning": "Purifying and cleansing. Clears old energy to make space for the new.",
      "color": "#3D5A28"
    },
    "frequency": {
      "hz": 396,
      "name": "Release Frequency",
      "description": "Liberates from the past, preparing you for new beginnings."
    },
    "practice": {
      "type": "Loop Interrupter",
      "title": "Rest Before Reacting",
      "description": "Rest before reacting to year-end noise. This is a great practice about what and where do you truly value your time and energy.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1669938813255-916a6ea376b9?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 41,
    "date": "December 29, 2026",
    "title": "The Threshold",
    "theme": "Between the Years",
    "cosmic": "You stand at the threshold between years. This liminal space between December and January is powerful—neither here nor there, full of potential.",
    "exercise": "Write a letter FROM your December 2026 self TO your March 2026 self (when you started). What would you tell them? This is the wisdom you've earned.",
    "affirmation": "I honor the threshold. I am complete and ready for new beginnings.",
    "crystal": {
      "name": "Spirit Quartz",
      "meaning": "Community crystal—each point represents a week of your journey, unified into one whole.",
      "color": "#E6E6FA"
    },
    "oil": {
      "name": "Frankincense & Myrrh",
      "meaning": "The ancient pair. Frankincense for beginnings, Myrrh for completions.",
      "color": "#DAA520"
    },
    "frequency": {
      "hz": 963,
      "name": "Threshold Frequency",
      "description": "The highest frequency—divine connection at the threshold."
    },
    "practice": {
      "type": "Somatic Anchor",
      "title": "Slow Your Breathing as the Year Turns",
      "description": "Slow your breathing as the year turns. Spend time with that which you value.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1598546275331-294954bef5ef?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 42,
    "date": "January 5, 2027",
    "title": "New Year's Light",
    "theme": "Fresh Intentions",
    "cosmic": "2027 begins! Capricorn season continues with its steady, building energy. Set intentions for the year with Saturn's disciplined wisdom.",
    "exercise": "Write 3 intentions for 2027. Make them specific. Read them aloud. Place them somewhere you'll see daily.",
    "affirmation": "I enter the new year with clarity and purpose. My intentions guide me.",
    "crystal": {
      "name": "Clear Quartz",
      "meaning": "The Master Healer returns. Program it with your 2027 intentions.",
      "color": "#F5F5F5"
    },
    "oil": {
      "name": "Lemon",
      "meaning": "Fresh start energy. Clears the old and welcomes the new.",
      "color": "#FFF44F"
    },
    "frequency": {
      "hz": 528,
      "name": "New Year Frequency",
      "description": "Transformation and fresh beginnings."
    },
    "practice": {
      "type": "Cognitive Tool",
      "title": "New Cycles, Same You",
      "description": "New cycles do not require new identities.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1680988469690-b0687fd61bcc?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 43,
    "date": "January 12, 2027",
    "title": "Wolf Moon",
    "theme": "Instinct & Intuition",
    "cosmic": "Wolf Moon (Full Moon) rises. Named for the wolves that howled in winter hunger, it calls us to trust our instincts.",
    "exercise": "What is your gut telling you right now? Close your eyes, place hands on belly, breathe deeply. Ask your body for guidance. Listen.",
    "affirmation": "I trust my instincts. My body knows the way.",
    "crystal": {
      "name": "Moonstone",
      "meaning": "Stone of intuition and the divine feminine. Enhances inner knowing.",
      "color": "#F0F0F0"
    },
    "oil": {
      "name": "Jasmine",
      "meaning": "Opens intuition and psychic channels. The night-blooming flower of wisdom.",
      "color": "#F8F4E3"
    },
    "frequency": {
      "hz": 852,
      "name": "Intuition Frequency",
      "description": "Awakens inner knowing and instinctual wisdom."
    },
    "practice": {
      "type": "Discernment Filter",
      "title": "What Deserves Your Focus?",
      "description": "What deserves your focus this quarter?",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1750547057489-192ee2f97456?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 44,
    "date": "January 19, 2027",
    "title": "Aquarius Season",
    "theme": "Innovation & Community",
    "cosmic": "Sun enters Aquarius on January 19th. The Water Bearer brings innovation, community consciousness, and humanitarian vision.",
    "exercise": "How can your personal growth serve the collective? Reflect on one way your journey can uplift others. We rise together.",
    "affirmation": "My light brightens the world. I am connected to all beings.",
    "crystal": {
      "name": "Amethyst",
      "meaning": "Stone of spiritual awareness and connection to higher consciousness.",
      "color": "#9966CC"
    },
    "oil": {
      "name": "Lavender",
      "meaning": "Calming and opening the third eye. Connects personal to universal.",
      "color": "#967BB6"
    },
    "frequency": {
      "hz": 852,
      "name": "Collective Frequency",
      "description": "Connects you to universal wisdom and community."
    },
    "practice": {
      "type": "Micro-Courage",
      "title": "One Visible Step Toward Alignment",
      "description": "Take one visible step toward alignment.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1768203630324-4a456ef7148f?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 45,
    "date": "January 26, 2027",
    "title": "Integration Week",
    "theme": "Weaving the Threads",
    "cosmic": "Deep in Aquarius season. As you approach the final stretch, begin weaving together all you've learned. Integration creates wisdom.",
    "exercise": "Review 3 favorite weeks from your journey. What thread connects them? What theme keeps emerging? This is your soul's message.",
    "affirmation": "I integrate all my experiences into wisdom. Nothing was wasted.",
    "crystal": {
      "name": "Fluorite",
      "meaning": "Stone of integration and mental clarity. Organizes information into understanding.",
      "color": "#8B5CF6"
    },
    "oil": {
      "name": "Ylang Ylang",
      "meaning": "Integrates heart and mind. Balances masculine and feminine wisdom.",
      "color": "#FFFACD"
    },
    "frequency": {
      "hz": 639,
      "name": "Integration Frequency",
      "description": "Harmonizes all aspects of your journey into wholeness."
    },
    "practice": {
      "type": "Emotional Barometer",
      "title": "Subtle Resentment",
      "description": "Notice subtle resentment before it calcifies.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1524914415733-3eb400768a13?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 46,
    "date": "February 2, 2027",
    "title": "Imbolc / Candlemas",
    "theme": "First Light of Spring",
    "cosmic": "Imbolc marks the halfway point between Winter Solstice and Spring Equinox. First stirrings of spring beneath the snow. Hope rises.",
    "exercise": "Light a candle for each area of your life you're grateful for. Watch them burn together. You have built so much light.",
    "affirmation": "I see the first light of spring within me. Hope stirs in my soul.",
    "crystal": {
      "name": "Selenite",
      "meaning": "Named for the moon goddess. Brings light into darkness, clarity into confusion.",
      "color": "#F0F0F0"
    },
    "oil": {
      "name": "Eucalyptus",
      "meaning": "Clears stagnation and opens breath. First breath of spring.",
      "color": "#44D7A8"
    },
    "frequency": {
      "hz": 528,
      "name": "Awakening Frequency",
      "description": "The miracle tone—first stirrings of transformation."
    },
    "practice": {
      "type": "Somatic Anchor",
      "title": "Hand on Sternum",
      "description": "Place a hand on your sternum before hard conversations.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1649113757783-80dd7ebf9859?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 47,
    "date": "February 9, 2027",
    "title": "Snow Moon",
    "theme": "Patience & Trust",
    "cosmic": "Snow Moon (Full Moon) illuminates the snow. Spring is coming but not yet here. Trust the timing. Practice patience.",
    "exercise": "Where are you rushing? What would happen if you slowed down? Write about one area where you can practice more patience.",
    "affirmation": "I trust divine timing. Everything arrives in its perfect moment.",
    "crystal": {
      "name": "Blue Calcite",
      "meaning": "Deeply calming. Helps you trust the process and wait with peace.",
      "color": "#ADD8E6"
    },
    "oil": {
      "name": "Melissa (Lemon Balm)",
      "meaning": "Ancient herb of patience and emotional healing.",
      "color": "#90EE90"
    },
    "frequency": {
      "hz": 432,
      "name": "Patience Frequency",
      "description": "The universal frequency—natural harmony and trust."
    },
    "practice": {
      "type": "Loop Interrupter",
      "title": "Interrupt Comparison Immediately",
      "description": "Interrupt comparison immediately.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1637633050426-395e3636f501?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 48,
    "date": "February 16, 2027",
    "title": "Pisces Season",
    "theme": "Dreams & Surrender",
    "cosmic": "Sun enters Pisces on February 18th. The final sign of the zodiac. Dreams, intuition, and surrender. Trust the universe to carry you.",
    "exercise": "Practice 'floating meditation': Lie down, close your eyes, imagine floating on calm water. Let the universe hold you. Surrender control.",
    "affirmation": "I trust the flow of life. I surrender to divine timing.",
    "crystal": {
      "name": "Amethyst",
      "meaning": "Stone of spiritual connection and intuitive dreams. Perfect for Pisces season.",
      "color": "#9966CC"
    },
    "oil": {
      "name": "Ylang Ylang",
      "meaning": "Opens the heart and enhances intuitive receptivity. Deeply surrendering.",
      "color": "#FFFACD"
    },
    "frequency": {
      "hz": 963,
      "name": "Surrender Frequency",
      "description": "Divine connection and trust in the universe."
    },
    "practice": {
      "type": "Cognitive Tool",
      "title": "Flexibility Is Strength",
      "description": "Flexibility is strength. \"We cannot solve our problems with the same thinking we used when we created them\" — Albert Einstein. \"The definition of insanity is doing the same thing over and over again and expecting different results... therefore the definition of sanity is the ability for one to change their own mind.\"",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1610099383582-d9fb4728c5c0?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 49,
    "date": "February 23, 2027",
    "title": "Dreams Before Dawn",
    "theme": "Vision & Imagination",
    "cosmic": "Deep in Pisces season, the veil between worlds is thin. Pay attention to your dreams. Your subconscious has messages for you.",
    "exercise": "Keep a dream journal this week. Write immediately upon waking, before dreams fade. Look for patterns and messages.",
    "affirmation": "My dreams guide me. My imagination creates my reality.",
    "crystal": {
      "name": "Labradorite",
      "meaning": "Stone of magic and dreams. Reveals hidden truths from the subconscious.",
      "color": "#1E3A5F"
    },
    "oil": {
      "name": "Clary Sage",
      "meaning": "Enhances dream clarity and spiritual vision. Opens third eye.",
      "color": "#87A96B"
    },
    "frequency": {
      "hz": 852,
      "name": "Dream Frequency",
      "description": "Opens intuition and enhances dream recall."
    },
    "practice": {
      "type": "Integration Prompt",
      "title": "What Capacity Has Grown Most?",
      "description": "What capacity has grown most this year?",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1758347262341-61a99a04e17a?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 50,
    "date": "March 2, 2027",
    "title": "Worm Moon",
    "theme": "Awakening Earth",
    "cosmic": "Worm Moon (Full Moon) rises as the earth begins to thaw. Earthworms emerge. Life stirs. Your journey is almost complete.",
    "exercise": "Go outside. Touch the earth—even if still cold. Feel the life stirring beneath the surface. You too are about to emerge.",
    "affirmation": "I am ready to emerge. My transformation is nearly complete.",
    "crystal": {
      "name": "Moss Agate",
      "meaning": "Stone of new beginnings and earth connection. Honors the emerging spring.",
      "color": "#7B8D42"
    },
    "oil": {
      "name": "Pine",
      "meaning": "Forest bathing in a bottle. Connects you to the awakening earth.",
      "color": "#234F1E"
    },
    "frequency": {
      "hz": 174,
      "name": "Earth Frequency",
      "description": "The lowest tone—connects to earth's awakening vibration."
    },
    "practice": {
      "type": "Emotional Barometer",
      "title": "How Has Your Reactivity Changed?",
      "description": "How has your reactivity changed since last spring?",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1591054333822-4f497183e9b7?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 51,
    "date": "March 9, 2027",
    "title": "The Final Week Before",
    "theme": "Completion Preparation",
    "cosmic": "One week before your journey's completion. Spring Equinox approaches. Prepare to complete this cycle with intention.",
    "exercise": "Review your entire 52-week journey. What are the 3 biggest transformations? Write them down. These are your gifts.",
    "affirmation": "I am transformed. I honor all I have become through this journey.",
    "crystal": {
      "name": "Ametrine",
      "meaning": "Combines completion (Amethyst) with new beginnings (Citrine). Perfect for transitions.",
      "color": "#9966CC"
    },
    "oil": {
      "name": "Neroli",
      "meaning": "For transitions and completions. Calms anxiety about endings and new beginnings.",
      "color": "#FFF8DC"
    },
    "frequency": {
      "hz": 639,
      "name": "Transition Frequency",
      "description": "Harmonizes endings and beginnings into one flow."
    },
    "practice": {
      "type": "Micro-Courage",
      "title": "Acknowledge Your Evolution",
      "description": "Acknowledge your evolution.",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1590243014495-5491de7112a7?w=1200&q=80",
    "imagePos": "center"
  },
  {
    "n": 52,
    "date": "March 16, 2027",
    "title": "Full Circle",
    "theme": "Completion & Rebirth",
    "cosmic": "Your 52-week journey completes just before the Spring Equinox (March 20, 2027). You began at spring's awakening; you end as spring returns. The cycle is complete.",
    "exercise": "Write a letter to yourself one year ago, when you began. Tell them everything you've learned. Then write a letter to yourself one year from now. What do you want them to know?",
    "affirmation": "I have walked 52 Tuesdays with intention. I am transformed. I am complete. I am ready to begin again.",
    "crystal": {
      "name": "Spirit Quartz",
      "meaning": "The community crystal—52 points unified into one. Your entire journey crystallized.",
      "color": "#E6E6FA"
    },
    "oil": {
      "name": "Frankincense & Myrrh",
      "meaning": "The sacred pair: endings and beginnings unified. The ancient oils of transformation.",
      "color": "#DAA520"
    },
    "frequency": {
      "hz": 963,
      "name": "Completion Frequency",
      "description": "The highest frequency—divine completion and readiness for the next cycle."
    },
    "practice": {
      "type": "Integration Prompt",
      "title": "What Strengthened You?",
      "description": "What strengthened you more than what shook you?",
      "practices": []
    },
    "image": "https://images.unsplash.com/photo-1642360670148-dc848a1da8bb?w=1200&q=80",
    "imagePos": "center"
  }
];
